import { useAuth } from '../../hooks/Auth';
import { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import api from '../../services/api';

import { Header } from '../../components/Header';
import { Sidebar } from '../../components/Sidebar';

import { Container, Content } from './styles';

import { FilterComponent } from './components/FilterComponent';
import { TableComponent } from './components/TableComponent';

import { InfoModal } from '../../components/Modal';
import { OrderDetails } from '../../components/OrderDetails/OrderDetails';
import { Invoice } from '../../Interfaces/HomeInterface';

export const Home = () => {
  const { data } = useAuth()

  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [querySearch, setQuerySearch] = useState<string>();

  const [showOrderDetails, setShowOrderDetails] = useState<boolean>(false);

  const [invoice, setInvoice] = useState<Invoice>();

  useEffect(() => {
    querySearch ? searchInvoices() : fetchInvoices();
  }, [querySearch]);

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const response = await api.get(`invoices`, {
        params: {
          page: 1,
          limit: 10,
          collection_completed: true,
          user_id: data?.user?.role?.name === 'Coleta'
              ? String(data?.user?.id)
              : undefined,
        }
      });

      if (response) {
        const invoices = data?.user?.role?.name === 'Coleta'
        ? response?.data?.results?.filter((invoice: Invoice) => !invoice.invoice_number)
        : response?.data?.results

        const total = data?.user?.role?.name === 'Coleta'
        ? invoices.length
        : response?.data?.total

        setInvoices(invoices);
        setPage(response?.data?.page);
        setTotal(total);
      }
    } catch (error: any) {
      handleError(error?.response?.data?.message || error?.toString());
    } finally {
      setLoading(false);
    }
  };

  const handleError = async (error: string) => {
    toast.error(error);
  };

  const handleChangePage = async (e: number) => {
    setLoading(true);

    try {
      const response = await api.get(`invoices`, {
        params: {
          page: e,
          limit: 50,
          collection_completed: true,
          user_id: data?.user?.role?.name === 'Coleta'
              ? String(data?.user?.id)
              : undefined,
        },
      });

      if (response) {
        const invoices = data?.user?.role?.name === 'Coleta'
        ? response.data.results.filter((invoice: Invoice) => !invoice.invoice_number)
        : response.data.results

        setInvoices(invoices);
        setPage(e);
      }
    } catch (error: any) {
      handleError(error.response?.data?.message || error.toString());
    } finally {
      setLoading(false);
    }
  };

  const searchInvoices = async () => {
    setLoading(true);
    try {
      const response = await api.get(`invoices${querySearch}`, {
        params: {
          collection_completed: true,
          limit: 10
        }
      });

      if (response) {
        const invoices = data?.user?.role?.name === 'Coleta'
        ? response.data.results.filter((invoice: Invoice) => !invoice.invoice_number)
        : response.data.results

        const total = data?.user?.role?.name === 'Coleta'
        ? invoices.length
        : response.data.total

        setInvoices(invoices);
        setPage(response.data.page);
        setTotal(total);
      }
    } catch (error: any) {
      handleError(error.response?.data?.message || error.toString());
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <Sidebar />

      <Container>
        <Content>
          <h1>Olá, Administrador!</h1>

          <p>
            Por favor, insira as informações necessárias sobre a coleta para
            prosseguir:
          </p>

          <FilterComponent {...{ setLoading }} {...{ setQuerySearch }} />

          <TableComponent
            {...{ invoices }}
            {...{ loading }}
            {...{ page }}
            {...{ total }}
            {...{ handleChangePage }}
            {...{ setInvoice }}
            {...{ setShowOrderDetails }}
          />
        </Content>
      </Container>

      <InfoModal
        openModal={showOrderDetails}
        setOpenModal={setShowOrderDetails}
      >
        <OrderDetails {...{ invoice }} {...{ setShowOrderDetails }} />
      </InfoModal>
    </>
  );
};
